namespace TabAurous.Production {
    export interface QualityInspectionItemsForm {
        TransId: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        DepartmentId: Serenity.IntegerEditor;
        ProcessId: Serenity.IntegerEditor;
        WorkerId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefVoucherId: Serenity.IntegerEditor;
    }

    export class QualityInspectionItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.QualityInspectionItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QualityInspectionItemsForm.init)  {
                QualityInspectionItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(QualityInspectionItemsForm, [
                    'TransId', w0,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'BagNo', w0,
                    'DepartmentId', w1,
                    'ProcessId', w1,
                    'WorkerId', w1,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'RefVoucherId', w1
                ]);
            }
        }
    }
}
